(function($) {

    $( '[off-canvas] .has-dropdown > a' ).on( 'click', function( event ) {
        event.preventDefault();

        $(this).next('.sub-menu').toggleClass('open');

        return false;
    } );

})(jQuery);